import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'
import { makeGuardFromSchema } from 'shared/api/requests/utils'

const TrialUnavailableErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('trial_unavailable'),
})

const ForbiddenAccountLegalEntityErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('forbidden_account_legal_entity'),
})

const TaxNumberInvalidFormatErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('tax_number_invalid_format'),
})

const TaxNumberErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('tax_number'),
})

const CustomerCreationFailedErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('customer_creation_failed'),
})

export const BillingFlexApiGuards = {
  isTrialUnavailableError: makeGuardFromSchema(TrialUnavailableErrorSchema),
  isTaxNumberInvalidFormatError: makeGuardFromSchema(TaxNumberInvalidFormatErrorSchema),
  isForbiddenAccountLegalEntityError: makeGuardFromSchema(ForbiddenAccountLegalEntityErrorSchema),
  isTaxNumberError: makeGuardFromSchema(TaxNumberErrorSchema),
  isCustomerCreationFailedError: makeGuardFromSchema(CustomerCreationFailedErrorSchema),
}
